import type {
  ColumnFiltersState,
  RowSelectionState,
} from '@tanstack/react-table';

import type { Filters, ProductFilters } from './productSelect.types';

/** The two inventory filter options, using the API's own values */
export const IN_STOCK = 'in_stock';
const OUT_OF_STOCK = 'out_of_stock';
export const INVENTORY_FILTER_VALUES = [IN_STOCK, OUT_OF_STOCK];

/**
 * `in_stock` is tri-state: true, false, or absent. Checking both boxes — or
 * neither — means don't filter on stock, so it returns undefined.
 */
export function toInStock(selected: string[] = []): boolean | undefined {
  const wantsInStock = selected.includes(IN_STOCK);

  return wantsInStock === selected.includes(OUT_OF_STOCK)
    ? undefined
    : wantsInStock;
}

export function getSelectedProducts<R extends { id: string | number }>(
  products: R[]
): RowSelectionState {
  return products.reduce<RowSelectionState>((acc, product) => {
    acc[product.id] = true;
    return acc;
  }, {});
}

export function getSelectedProductIds(ids: string[]): RowSelectionState {
  return ids.reduce<RowSelectionState>((acc, product) => {
    acc[product] = true;
    return acc;
  }, {});
}

export function getSelectedFilters(filters: Filters): ColumnFiltersState {
  return Object.entries(filters).map((filter) => {
    const id = filter[0] as ProductFilters;
    return {
      id,
      value: filter[1],
    };
  });
}

export function columnFiltersToFilters(
  columnFilters: ColumnFiltersState
): Filters {
  return columnFilters.reduce<Filters>((acc, filter) => {
    acc[filter.id as ProductFilters] = filter.value as string | string[];

    return acc;
  }, {});
}
